import contextMenu from '../components/contextmenu/index';
import { connect } from 'react-redux';
//import { setPoint } from '../routing/actions';
import { map } from '../map/map';
import { showMenu, setText } from './actions';
//import { revGeoAddress } from '../reverseGeocoding/actions';
import { drawLayer, drawSource } from '../draw/mapAssets';
import {transform} from 'ol/proj';
//import {isMaxPointsReached} from '../routing/reducer';

const getDrawFeaturesInPixel = (pixel) => {

  var features = [];
  map.forEachFeatureAtPixel(pixel, (feature)=>{
    features.push(feature);
  }, {
    layerFilter: (layer)=>{
        return (layer === drawLayer);
    },
    hitTolerance: 5
  });

  return features;
}

const makeDescription = (feature, format) => {
  if (!feature) {
    return '';
  }
  
  if (!format) {
    const name = feature.get('name');
    const category = feature.get('category', null);
  
    if (!category) {
      return name;
    }
  
    return [name, category].join(' - ');
  }

  return format(feature.values_);
}

const mapStateToPropsRes = (state) => {

  var items = [ ];
  
  const wgsCoords = transform(state.contextmenu.coords, 'EPSG:3857', 'EPSG:4326');
  const lksCoords = transform(state.contextmenu.coords, 'EPSG:3857', 'EPSG:3059'); //3059

  const coordText = "Lat: " + parseFloat(wgsCoords[1]).toFixed(6) + ", Lon: " + parseFloat(wgsCoords[0]).toFixed(6);
  const coordTextLks = "LKS: X: " + parseFloat(lksCoords[0]).toFixed(0) + ", Y: " + parseFloat(lksCoords[1]).toFixed(0);
  
  const drawingsinPixel = getDrawFeaturesInPixel(state.contextmenu.pixel);

  if(state.contextmenu.pixel.length > 0 && drawingsinPixel.length > 0) {
    items.push({id: 'delete_feature', name: "Dzēst"});
  }

  return {
  	isRoutingAllowed: false, //isMaxPointsReached(state.routing.waypoints.length),
  	position: state.contextmenu.pixel,
  	items: items,
    title: makeDescription(drawingsinPixel[0], state.contextmenu.format),
    coords: coordText,
    coordsLKS: coordTextLks
  };
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickOutside: () => {

      dispatch(showMenu(null));
    },
    clickHandler: (ev, data, item) => {
      var coord = map.getCoordinateFromPixel(data);

      if(item.id === 'delete_feature') {
        var features = getDrawFeaturesInPixel(data);

        if(features.length > 0) {
          drawSource.removeFeature(features[0]);
        }
        
      }
      
      dispatch(showMenu(null));

      if(item.id === 'route_from' || item.id === 'route_to') {
      //  dispatch(setPoint(coord));
        
      //  dispatch(revGeoAddress(coord));
      }
      return;
    }
  };
};

const mapPopupContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(contextMenu);

export default mapPopupContainer;